import React from "react";
import DialogueBatch from "../Narrative/DialogueBatch";

const HelpModal = ({ isVisible, onClose, script: currScript }) => {
  if (!isVisible) return null;
  const handleBackgroundClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <React.Fragment>
      <div
        className="fixed inset-0 bg-black bg-opacity-50 flex flex-col justify-center items-center z-[100]"
        onClick={handleBackgroundClick}
      >
        <div className="bg-white rounded-lg w-2/3 shadow-lg relative">
          <button
            className="absolute top-0 right-2 text-3xl text-gray-500 hover:text-white"
            onClick={onClose}
          >
            &times;
          </button>
          {currScript && <DialogueBatch step={currScript} />}
        </div>
      </div>
    </React.Fragment>
  );
};

export default HelpModal;
